import { render } from "./OscarPoolSetupPage.vue?vue&type=template&id=b68b08c0&scoped=true"
import script from "./OscarPoolSetupPage.vue?vue&type=script&lang=js"
export * from "./OscarPoolSetupPage.vue?vue&type=script&lang=js"

import "./OscarPoolSetupPage.vue?vue&type=style&index=0&id=b68b08c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b68b08c0"]])

export default __exports__